var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/magnifying-glass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0665 5.59971C10.2064 5.59971 6.26646 9.5396 6.26646 14.3997C6.26646 19.2598 10.2064 23.1997 15.0665 23.1997C17.4968 23.1997 19.6952 22.216 21.289 20.6222C22.8828 19.0284 23.8665 16.8301 23.8665 14.3997C23.8665 9.5396 19.9266 5.59971 15.0665 5.59971ZM3.86646 14.3997C3.86646 8.21412 8.88087 3.19971 15.0665 3.19971C21.252 3.19971 26.2665 8.21412 26.2665 14.3997C26.2665 17.0597 25.338 19.5046 23.7892 21.4254L29.115 26.7512C29.5836 27.2198 29.5836 27.9796 29.115 28.4482C28.6464 28.9169 27.8866 28.9169 27.4179 28.4482L22.0922 23.1225C20.1714 24.6712 17.7265 25.5997 15.0665 25.5997C8.88087 25.5997 3.86646 20.5853 3.86646 14.3997Z",
    fill: "#22C55E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.09f78c7ec0be36a57099fe9fc610634e.svg";
export { ForwardRef as ReactComponent };